import { defineComponent as _defineComponent } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import AppIcon from '../ui/icon/AppIcon.vue'
import Teleport from 'vue2-teleport'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeLoadingScreen',
  setup(__props) {

const breakpoints = useBreakpoints(breakpointsTailwind)

return { __sfc: true,breakpoints, AppIcon, Teleport }
}

})